import _ from 'lodash';
import { colShape, getColClass } from './utils';
const lastRowSelector = '> .column > .row:last-child, > .column > .row:last-of-type, > .column > .row:only-child, > .column > .row:only-of-type';

export default function columns() {
  return {
    _id: false,
    type: 'puddle.columns',
    equalHeights: false,
    columns: _.times(2, colShape(getColClass(2))),
    pageCSS: '',
    bounceDroplet: false,
    lastRowSelector,
    mediaQueries: [
      {
        selector: '> .column',
        properties: [
          {
            property: 'transformX',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'transformY',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'rotate',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: ', > .column',
        properties: [
          {
            property: 'display',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: lastRowSelector,
        properties: [
          {
            property: 'margin-bottom',
            desktop: '0px',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/columns/droplet.schema.js